<template>
  <div class="my-2">
    <v-alert
      dense
      outlined
      close-icon="mdi-close-circle"
      v-show="showAlert"
      type="error"
    >
      <p>{{ $t("errorOccurred") }}</p>
      <div class="d-flex" v-for="(item, i) in alertContent" :key="i">
        {{ item }}
      </div>
    </v-alert>
    <div
      class="dropZone"
      @dragenter="dragging = true"
      @dragleave="dragging = false"
      @drag="onChange"
    >
      <div class="dropZone-info" v-if="!isFilesWasDropped">
        <v-icon class="mx-2">mdi-cloud-upload-outline</v-icon>
        <span class="dropZone-title">{{ $t("uploadText") }}</span>
      </div>
      <input
        type="file"
        ref="inputRef"
        @change="onChange"
        :accept="contentMediaType"
        :multiple="multipleFlag"
      />
      <div v-if="isFilesWasDropped">
        <v-row dense v-for="(item, i) in localFiles" :key="i" class="my-1">
          <v-col cols="10" class="d-flex align-center">
            <v-icon
              size="20"
              class="mx-1"
              @click="deleteFile(item)"
              style="cursor: pointer"
              >mdi-close
            </v-icon>

            <span class="mr-2">{{ item.name }}</span>

            <v-progress-linear
              v-if="!item.uploadFlag"
              class="mx-2"
              color="blue-grey"
              indeterminate
              rounded
              height="6"
              style="width: 40px"
            ></v-progress-linear>

            {{ item.alertIcon }}
            <v-icon
              v-if="item.uploadFlag && item.alertIcon !== undefined"
              size="22"
              color="error"
              >{{ item.alertIcon }}
            </v-icon>

            <span v-if="item.tags !== undefined">
              <v-chip
                v-for="(tag, i) in item.tags"
                :key="i"
                class="mx-2"
                v-bind="localChipsPropsForShowTag"
                close
                @click:close="deleteTagFromFile(item, tag)"
              >
                {{ tag[localItemTitle] }}
              </v-chip>
            </span>
            <v-icon
              v-if="
                fileTagFeature &&
                item.uploadFlag &&
                item.alertIcon === undefined
              "
              size="20"
              class="mx-2"
              @click="openDialog(item)"
            >
              mdi-tag-plus-outline
            </v-icon>
          </v-col>
          <v-col v-if="i === 0 && files.length > 1" cols="2" align="right">
            <v-chip
              @click="deleteAllFiles"
              small
              color="grey lighten-1"
              class="mr-1"
            >
              {{ $t("deleteAllFilesLabel") }}
              <v-icon class="ml-1" small>mdi-close-circle</v-icon>
            </v-chip>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog v-model="dialog" v-bind="localDialogProps">
      <v-card>
        <v-card-title> Tagowanie plików </v-card-title>
        <v-card-text>
          <v-combobox
            :item-text="localItemTitle"
            :item-value="localItemKey"
            v-model="dialogCombo.model"
            :items="dialogCombo.items"
            :search-input.sync="dialogCombo.search"
            v-bind="localComboProps"
            @input="createNewObjTag"
          >
            <template v-slot:selection="data">
              <v-chip
                :key="data.item[localItemKey]"
                v-bind="localChipsProps"
                :input-value="data.selected"
                :disabled="data.disabled"
                @click:close="data.parent.selectItem(data.item)"
              >
                {{ data.item[localItemTitle] }}
              </v-chip>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    No results matching "<strong>{{
                      dialogCombo.search
                    }}</strong
                    >". Press <kbd>enter</kbd> to create a new one
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
          <div class="item-box d-flex">
            <div v-for="(item, i) in dialogCombo.items.slice(0, 10)" :key="i">
              <v-chip
                :key="localItemKey"
                class="mx-2"
                v-bind="localChipsPropsForShowTag"
                @click="addToComboModelOnClickChip(item)"
              >
                {{ item[localItemTitle] }}
              </v-chip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="gray" @click="closeDialog" style="text-transform: none">
            Zamknij
          </v-btn>

          <v-btn
            color="success"
            @click="addTagToFile"
            style="text-transform: none"
          >
            Dodaj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isValidUrl, renameFile, slugify } from "./shared/shared";
import { v4 as uuidv4 } from "uuid";

const multipartFileAxiosConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export default {
  name: "TcnFileDropzone",
  components: {},
  props: {
    value: { default: "" },
    options: { type: Object, required: true },
    schema: { type: Object, required: true },
    fullSchema: { type: Object, required: true },
    fullKey: { type: String, required: true },
    label: { type: String, default: "" },
    htmlDescription: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, required: true },
    on: { type: Object, required: true },
  },
  data() {
    return {
      files: [],
      dragging: false,

      url: "",
      responseStructure: {},

      resultArray: [],
      alertContent: [],

      dialog: false,
      dialogCombo: {
        model: [],
        items: [],
        search: "",
      },
      selectedFile: null,
    };
  },
  computed: {
    newTagCreateMode() {
      return this.schema?.dialogConfig?.["id-generator"] || "slug";
    },

    multipleFlag() {
      return this.schema["multiple"] || false;
    },

    fileLimit() {
      if (!this.multipleFlag) {
        return 1;
      } else {
        return this.schema["fileLimit"] || 10;
      }
    },

    contentMediaType() {
      return this.schema["contentMediaType"] || "*/*";
    },

    fileTagFeature() {
      return this.schema["fileTagFeature"] || false;
    },

    fileSizeLimitInMB() {
      return this.schema["fileSizeLimitInMB"] || 5;
    },

    localFiles() {
      return this.files;
    },

    showAlert() {
      return this.alertContent.length > 0;
    },

    isFilesWasDropped() {
      return this.files.length > 0;
    },

    localItemTitle() {
      return this.schema?.dialogConfig?.["x-itemTitle"] || "name";
    },

    localItemKey() {
      return this.schema?.dialogConfig?.["x-itemKey"] || "value";
    },

    localDialogProps() {
      const dialogProps = {
        "max-width": 500,
        persistent: false,
      };

      return { ...dialogProps, ...this.schema.dialogConfig?.["dialogProps"] };
    },

    localComboProps() {
      const defaultProps = {
        multiple: true,
        clearable: true,
        label: "Wpisz nazwę znacznika...",
        "prepend-inner-icon": "mdi-magnify",
        chips: true,
        "deletable-chips": true,
        "hide-selected": true,
      };
      const global = this.options["fieldProps"];
      const textField =
        this.options["comboboxProps"] !== undefined &&
        this.options["comboboxProps"] !== null
          ? this.options["comboboxProps"]
          : {};
      const forThis =
        this.schema.dialogConfig?.["comboboxProps"] !== undefined &&
        this.schema.dialogConfig["comboboxProps"] !== null
          ? this.schema.dialogConfig["comboboxProps"]
          : {};
      let result = { ...defaultProps, global };
      result = { ...result, ...textField };
      result = { ...result, ...forThis };
      return result;
    },

    localChipsProps() {
      const defaultProps = {
        close: true,
        "close-icon": "mdi-close-circle-outline",
        outlined: true,
      };
      const forThis =
        this.schema.dialogConfig?.["chipsProps"] !== undefined &&
        this.schema.dialogConfig["chipsProps"] !== null
          ? this.schema.dialogConfig["chipsProps"]
          : {};
      return { ...defaultProps, forThis };
    },

    localChipsPropsForShowTag() {
      let result = JSON.parse(JSON.stringify(this.localChipsProps));
      result.close = false;
      return result;
    },

    uploadParam() {
      return this.schema["uploadParam"] || "file";
    },
  },
  watch: {
    resultArray: {
      handler() {
        console.log(this.resultArray);
        if (!this.multipleFlag) {
          this.$emit("input", {
            key: this.fullKey,
            value: this.resultArray[0],
          });
        } else {
          this.$emit("input", { key: this.fullKey, value: this.resultArray });
        }
      },
      deep: true,
    },
  },

  methods: {
    async onChange(e) {
      let incomingFiles = Array.from(e.target.files || e.dataTransfer.files);

      incomingFiles.forEach((file) => {
        if (this.files.some((item) => item.name === file.name)) {
          let fileCopyRegExp = this.filenameRegexp(file.name);
          let fileNameArray = this.files.filter(
            (item) => item.name === file.name || fileCopyRegExp.test(item.name)
          );
          let splitName = file.name.split(".");
          file = renameFile(
            file,
            `${splitName[0]} (${fileNameArray.length}).${splitName[1]}`
          );
        }

        file.uploadFlag = false;
        if (this.isValid(file)) {
          if (this.files.length !== 0 && !this.multipleFlag) {
            // single file
            this.files = [];
            this.resultArray = [];
          }
          this.files.push(file);
          this.upload(file);
        }
      });

      let dt = new DataTransfer();
      this.$refs.inputRef.files = dt.files;
    },

    async upload(file) {
      const formData = new FormData();
      formData.append(this.uploadParam, file);

      await this.options.httpLib
        .post(`${this.url}`, formData, multipartFileAxiosConfig)
        .then((response) => {
          let data = response.data;
          // let keys = Object.keys(this.schema.properties)
          // let obj = {}
          // keys.forEach(key => {
          //   obj[key] = data[key]
          // })
          let obj = {};
          obj.id = data.id;
          this.resultArray.push(obj); // add to result
          let index = this.files.findIndex((i) => i === file);
          file.id = obj.id;
          this.$set(this.files, index, file);
          file.uploadFlag = true;
        })
        .catch((error) => {
          console.log(error);
          let index = this.files.findIndex((i) => i === file);
          file.alertIcon = "mdi-alert-octagon-outline";
          this.$set(this.files, index, file);
          file.uploadFlag = true;
          this.alertContent.push(this.$t("uploadError", { name: file.name }));
        });
    },

    isValid(file) {
      if (this.files.length < this.fileLimit) {
        if (
          this.contentMediaType !== "*/*" &&
          !file.type.match(this.contentMediaType)
        ) {
          this.alertContent.push(
            this.$t("contentTypeMessage", { name: file.name })
          );
          return false;
        } else if (
          !(
            (file.size / (1024 * 1024)).toFixed(2) <=
            this.fileSizeLimitInMB.toFixed(2)
          )
        ) {
          this.alertContent.push(
            this.$t("sizeFileLimit", {
              name: file.name,
              size: this.fileSizeLimitInMB,
            })
          );
          return false;
        } else {
          return true;
        }
      } else {
        this.alertContent.push(
          this.$t("limitMessage", { name: file.name, limit: this.fileLimit })
        );
        return false;
      }
    },

    deleteAllFiles() {
      this.files.forEach((item) => {
        this.deleteFile(item);
      });
      this.files = [];
      this.resultArray = [];
      this.clearAlert();
    },

    deleteFile(file) {
      if (file.id !== undefined) {
        this.options.httpLib
          .delete(`${this.url}/${file.id}`)
          .then((response) => {
            let status = response.status;
            if (status === 204) {
              this.files = this.files.filter((item) => item !== file);
              this.resultArray = this.resultArray.filter(
                (item) => item.id !== file.id
              );
            }
            this.clearAlert();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.files = this.files.filter((item) => item !== file);
        this.resultArray = this.resultArray.filter(
          (item) => item.id !== file.id
        );
        this.clearAlert();
      }
    },

    deleteTagFromFile(item, tag) {
      const indexRaw = this.files.findIndex((file) => file.id === item.id);
      const indexResult = this.resultArray.findIndex(
        (file) => file.id === item.id
      );

      let localRaw = this.files[indexRaw];
      localRaw.tags = this.files[indexRaw].tags.filter((t) => t !== tag);

      let localResult = this.resultArray[indexResult];
      localResult.tags = this.resultArray[indexResult].tags.filter(
        (t) => t !== tag
      );

      this.$set(this.files, indexRaw, localRaw);
      this.$set(this.resultArray, indexResult, localRaw);
    },

    clearAlert() {
      this.alertContent = [];
    },

    openDialog(file) {
      this.dialog = true;
      this.selectedFile = file;
      if ("tags" in file) {
        this.dialogCombo.model = file.tags;
      }
    },

    closeDialog() {
      this.dialogCombo.model = null;
      this.selectedFile = null;
      this.dialog = false;
    },

    addToComboModelOnClickChip(tag) {
      if (!this.dialogCombo.model.some((item) => item === tag)) {
        this.dialogCombo.model.push(tag);
      }
    },

    addTagToFile() {
      this.selectedFile.tags = this.dialogCombo.model;
      const index = this.files.findIndex(
        (item) => item.id === this.selectedFile.id
      );
      const resultIndex = this.resultArray.findIndex(
        (item) => item.id === this.selectedFile.id
      );
      this.files[index] = this.selectedFile;

      //update result array
      let val = this.resultArray[resultIndex];
      val.tags = this.dialogCombo.model;
      this.$set(this.resultArray, index, val);
      this.dialogCombo.model = [];
      this.dialog = false;
    },

    createNewObjTag(val) {
      val.forEach((item) => {
        if (typeof item === "string") {
          this.dialogCombo.model = this.dialogCombo.model.filter(
            (x) => x !== item
          );
          let obj = {};
          obj[this.localItemTitle] = item;
          if (this.newTagCreateMode === "uuid") {
            obj[this.localItemKey] = uuidv4();
          } else {
            obj[this.localItemKey] = slugify(item);
          }

          this.dialogCombo.model.push(obj);
        }
      });
    },

    filenameRegexp(filename) {
      let t = filename.split(".")[0];
      return new RegExp(`${t}[ ]\\([1-9]\\)`);
    },

    printConfig() {
      console.log("Wiele plików: " + this.multipleFlag);
      console.log("ContentType: " + this.contentMediaType);
      console.log("Ficzer tagowania: " + this.fileTagFeature);
      console.log("Limit plików: " + this.fileLimit);
    },

    async loadTagsFromAPI() {
      this.options.httpLib
        .get(`${this.schema?.dialogConfig?.["x-source"]}`)
        .then((response) => {
          this.dialogCombo.items = response.data;
        })
        .catch((err) => {
          this.alertContent.push(this.$t("dictionaryFetchError"));
          console.log(err);
        });
    },
  },
  mounted() {
    this.url = this.schema["fileUrl"];

    if (this.fileTagFeature) {
      if (this.schema?.dialogConfig?.["x-source"] instanceof Array) {
        this.dialogCombo.items = this.schema?.dialogConfig?.["x-source"];
      } else if (isValidUrl(this.schema?.dialogConfig?.["x-source"])) {
        this.loadTagsFromAPI();
      } else {
        console.error("Zła konfiguracja pola x-source w obiekcie dialogConfig");
      }
    }

    this.printConfig();
  },
};
</script>
<i18n lang="i18n">
{
  "pl": {
    "uploadText": "Dodaj lub upuść pliki aby wgrać",
    "deleteAllFilesLabel": "Usuń wszystkie pliki",
    "errorOccurred": "Wystąpił błąd",
    "limitMessage": "Plik o nazwie {name} nie został dodany - Przekroczono limit załączników (max. {limit} załączników.)",
    "contentTypeMessage": "Plik o nazwie {name} nie został dodany - Niezgodny typ pliku.",
    "dictionaryFetchError": "Wystąpił błąd podczas pobierania listy tagów ze słownika.",
    "sizeFileLimit": "Plik o nazwie {name} nie może być wgrany, przekroczono dozwolony rozmiar pliku: {size} MB.",
    "uploadError": "Nie udało się wgrać pliku o nazwie {name}."
  },
  "en": {
    "uploadText": "Drop file or click to upload",
    "deleteAllFilesLabel": "Delete all files",
    "errorOccurred": "Error occurred",
    "limitMessage": "File named {name} was not added - Attachment limit exceeded (max {limit} attachments).",
    "contentTypeMessage": "File named {name} was not added - Incompatible file type.",
    "dictionaryFetchError": "An error occurred while retrieving the tag list from the dictionary.",
    "sizeFileLimit": "File named {name} cannot be uploaded, the allowed file size has been exceeded: {size} MB.",
    "uploadError": "File named {name} cannot be uploaded"
  }
}
</i18n>

<style scoped lang="css">
.dropZone {
  min-height: 140px;
  position: relative;
  border: 3px dashed gray;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 80%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>
